import './SidebarStep.css'
import cx from 'classnames'
import { CheckCircleIcon, DashedCircleIcon } from '../icons'

export function SidebarStep({
  children,
  className,
  isComplete,
  isActive
}: {
  isComplete: boolean
  className?: string
  children: React.ReactNode
  isActive: boolean
}) {
  return (
    <div className={cx('sidebar-step', { 'sidebar-step-active': isActive }, className)}>
      <div className="sidebar-step-content">{children}</div>
      {isComplete ? (
        <CheckCircleIcon className="sidebar-step-icon-complete" />
      ) : (
        <DashedCircleIcon className="sidebar-step-icon-incomplete" />
      )}
    </div>
  )
}
